<template>
  <!-- 通用信息卡片：标题栏 + 内容插槽 -->
  <section class="pt-card">
    <header class="pt-card__head">
      <h2 class="pt-card__title">{{ title }}</h2>
      <a v-if="channel" class="pt-card__more" @click="goChannel">更多<span>+</span></a>
    </header>
    <div class="pt-card__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: { type: String, default: '' },
    channel: { type: String, default: '' },
    needLogin: { type: Boolean, default: false }
  },
  methods: {
    goChannel: function () {
      if (!this.channel) return
      // 父组件监听了 more-click → 完全委托给父组件
      if (this.$listeners && this.$listeners['more-click']) {
        this.$emit('more-click')
        return
      }
      if (this.needLogin && !this.isLoggedIn()) {
        this.$emit('require-login')
        return
      }
      this.$router.push('/portal/' + this.channel)
    },
    isLoggedIn: function () {
      return !!window.localStorage.getItem('token')
    }
  }
}
</script>

<style lang="less" scoped>
.pt-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.pt-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pt-line-2, #e5e7eb);
}
.pt-card__title {
  position: relative;
  margin: 0;
  padding-left: 12px;
  font-size: 17px;
  font-weight: 700;
  color: var(--pt-ink, #1f2937);
}
.pt-card__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: var(--pt-brand, #1e63b0);
}
.pt-card__more {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: var(--pt-muted, #9ca3af);
  cursor: pointer;
  transition: color 0.2s;
}
.pt-card__more:hover {
  color: var(--pt-brand, #1e63b0);
}
.pt-card__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 8px 16px 12px;
  padding: 0px 16px 0px;
}
</style>
